"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    rubricAnalysis: {
        title: 'Item Analysis',
        matrix: {
            button: 'View Checklist',
            legend: 'Percentage of students who earned a check',
            modalTitle: 'Checklist for {{assessment}}',
            word: 'Word {{value}}',
            criterion: 'Criterion {{value}}',
        },
        rating: {
            button: 'View Rubric',
            legend: 'Percent of students who earn EE or ME',
            modalTitle: 'Rubric for {{assessment}}',
        },
        passage: {
            modalTitle: 'Rubric for {{assessment}}',
        },
        printButton: {
            title: 'Print',
            ariaLabelText: {
                matrix: {
                    ariaLabel: 'Print for Checklist',
                },
                rating: {
                    ariaLabel: 'Print for Rubric',
                },
                passage: {
                    ariaLabel: 'Print for Rubric',
                },
            },
        },
        ariaLabel: {
            rubricAnalysisLabel: 'rubric analysis for {{title}}',
        },
    },
};
